<template>
      <div>
            <b-row class="d-flex flex-nowrap align-items-start">
                  <b-col sm="6">
                        <b-form-group label="Tipo(s) de Fraude" class="col">
                              <multiselect class="multiselect-primary" v-model="model.tiposFraudeSelecionados"
                                    :options="this.tiposFraude" :multiple="true" label="text" value="value"
                                    track-by="text" :hide-selected="true" placeholder="Todos" />
                        </b-form-group>
                  </b-col>
                  <b-col sm="3">
                        <b-form-group label="Documento Federal" class="col">
                              <b-input v-model="model.documentoFederal" placeholder="Todos"
                                    v-mask="documentMask" />
                        </b-form-group>
                  </b-col>
                  <b-col sm="3">
                        <b-form-group>
                              <h6>Somente Com Fraude Reportada
                              </h6>
                              <label class="switcher">
                                    <input type="checkbox" v-model="model.somenteComFraudeReportada"
                                          class="switcher-input" />
                                    <span class="switcher-indicator">
                                          <span class="switcher-yes">
                                                <span class="ion ion-md-checkmark"></span>
                                          </span>
                                          <span class="switcher-no">
                                                <span class="ion ion-md-close"></span>
                                          </span>
                                    </span>
                                    <span class="switcher-label">
                                          {{ model.somenteComFraudeReportada ? 'Sim' : 'Não' }}
                                    </span>
                              </label>
                        </b-form-group>
                  </b-col>
            </b-row>
      </div>
</template>
<script>

import Multiselect from 'vue-multiselect'
import { getDocumentMask } from '@/helpers/masks'

export default {
      components: {
            Multiselect
      },
      props: {
            value: { type: Object },
      },
      computed: {
            documentMask () {
                  const v = this.model.documentoFederal || null
                  return getDocumentMask(v)
            },

            model: {
                  get() {
                        var obj = this.value
                        return obj
                  },
                  set(value) {
                        this.$emit('input', value)
                  },
            },
      },
      data() {
            return {
                  tiposFraude: [
                        {
                              text: "Application Frauds",
                              value: this.$api.Enums.IndicadorFraude.FraudesAplicadas
                        },
                        {
                              text: "Mule Accounts",
                              value: this.$api.Enums.IndicadorFraude.ContasMula
                        },
                        {
                              text: "Scammer Accounts",
                              value: this.$api.Enums.IndicadorFraude.ContasGolpistas
                        },
                        {
                              text: "Other Frauds",
                              value: this.$api.Enums.IndicadorFraude.OutrasFraudes
                        },
                        {
                              text: "Unknown Frauds",
                              value: this.$api.Enums.IndicadorFraude.FraudesDesconhecidas
                        },
                        {
                              text: "Rejected Reports",
                              value: this.$api.Enums.IndicadorFraude.RelatosRejeitados
                        },
                  ],
            }
      },
      methods: {
            refresh() {
                  this.$emit('refresh')
            }
      },
}
</script>
